var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfobluIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#1da193",
    width: 61.721,
    height: 61.721,
    viewBox: "0 0 61.721 61.721",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "info_FILL1_wght400_GRAD0_opsz48",
    d: "M35.092,50.291a2.243,2.243,0,0,0,2.315-2.315V34.012a2.1,2.1,0,0,0-.694-1.582,2.285,2.285,0,0,0-1.62-.656,2.243,2.243,0,0,0-2.315,2.315V48.053a2.1,2.1,0,0,0,.694,1.582A2.285,2.285,0,0,0,35.092,50.291ZM34.86,26.065a2.535,2.535,0,0,0,1.813-.694,2.337,2.337,0,0,0,.733-1.774,2.593,2.593,0,0,0-.733-1.852,2.516,2.516,0,0,0-3.626,0,2.593,2.593,0,0,0-.733,1.852,2.337,2.337,0,0,0,.733,1.774,2.535,2.535,0,0,0,1.813.694Zm0,39.656a31.3,31.3,0,0,1-12.19-2.353A29.869,29.869,0,0,1,6.353,47.05,31.3,31.3,0,0,1,4,34.86,31.1,31.1,0,0,1,6.353,22.748a30.119,30.119,0,0,1,6.519-9.8A30.767,30.767,0,0,1,34.86,4a30.613,30.613,0,0,1,30.86,30.86,30.767,30.767,0,0,1-8.95,21.988,30.119,30.119,0,0,1-9.8,6.519A31.1,31.1,0,0,1,34.86,65.721Z",
    transform: "translate(-4 -4)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfobluIcon);
export default __webpack_public_path__ + "static/media/infoblu_icon.6f8d420ed0c992bd024693a18bef60a5.svg";
export { ForwardRef as ReactComponent };